import axiosInstance from "../../interceptor";

const AppApi = {
  loadSettings: () => axiosInstance.get('/registry/google_key'),
};

export default AppApi;